package viewer

import kotlinx.html.*
import org.w3c.dom.HTMLElement
import util.InstructionsUI

object ViewerInstructions {
    /**
     * Adds the FAB and the instructions element as a child of the given [parent].
     */
    fun addHtmlTo(parent: TagConsumer<HTMLElement>) {
        InstructionsUI.addInstructionsHtmlTo(parent) {
            h2 { +"Navigation" }
            p {
                +"Verwende einen Finger, um das Modell zu drehen. Verwende zwei Finger, um zu zoomen oder das Modell zu verschieben."
            }
            h2 { +"Welcher Baustein ist das?" }
            p {
                +"""
                    Tippe auf einen beliebigen Baustein. Dann öffnet sich eine Übersicht, auf der zu sehen ist,
                    welche Breite und Länge der Baustein hat. Außerdem kannst du das Modell drehen, um zu sehen,
                    wie genau er eingebaut ist.
                """
            }
            p {
                +"Um die Baustein-Ansicht danach wieder zu schließen, tippe auf eine freie Fläche."
            }
            h2 { +"Was für Bausteine gibt es?" }
            ul {
                li { +"Brixi: Verbindungsstein" }
                li { +"Twister: Zylinderform, die zwei Brixis verbindet" }
                li { +"No. 1: dünnster Baustein (in 4 verschiedenen Längen)" }
                li { +"No. 2: doppelt so breit wie No. 1 (in 4 verschiedenen Längen)" }
                li { +"No. 4: viermal so breit wie No. 1 (nur in einer Länge)" }
                li { +"Wheels: Achse mit zwei Rädern" }
            }
        }
    }
}